<template>
  <q-dialog v-model="props.dialog">

    <q-card>
      <q-chip square
              color="info">Esta nota se mostrará en el desplegable</q-chip>
      <div class="q-pa-xs">
        <q-list bordered
                separator>
          <q-item>
            <q-item-section>
              <q-input label="Notas"
                       clearable
                       dense
                       v-model="notas"
                       autogrow></q-input>
            </q-item-section>
          </q-item>
          <q-item v-ripple>
            <q-item-section>
              <q-btn label="Cancelar"
                     color="negative"
                     @click="cancel"></q-btn>
            </q-item-section>
            <q-item-section>
              <q-btn label="Aceptar"
                     color="primary"
                     @click="send"></q-btn>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue';
const props = defineProps({ data: {}, table: '', dialog: false })
const emit = defineEmits(["dialog", "done"])
const global = inject("global")
const notas = ref()
async function send() {
  emit("dialog", true)
  let sendData = {
    Notas: notas.value,
    Usuario: global.user.name
  }
  notas.value = '';
  props.data.hasOwnProperty('Poliza') ? sendData = { ...sendData, Poliza: props.data.Poliza } : null;
  props.data.hasOwnProperty('Fecha') ? sendData = { ...sendData, Fecha: props.data.Fecha } : null;
  props.data.hasOwnProperty('Siniestro') ? sendData = { ...sendData, Siniestro: props.data.Siniestro } : null;
  await global.db("/app/db/insNota",{
    table: props.table,
    query: "insert",
    data: sendData
  });
  emit("done", true);
}
function cancel() {
  notas.value = '';
  emit("dialog", true)
}
function init() {
  notas.value = '';
}
onMounted(() => { init() })
</script>
